@if (seasons().length > 1) {
    <p-select class="season-select block mb-4 w-64" appendTo="body" data-testid="details_seasons"
        [options]="seasons()" [ngModel]="selectedSeasonId()"
        optionLabel="title" optionValue="referenceId"
        (onChange)="seasonChange.emit($event.value)">
        <ng-template #dropdownicon><i class="pi pi-chevron-down"></i></ng-template>
    </p-select>
}

<div class="episodes-list">
    @for (episode of episodes(); track episode.referenceId) {
        <asset-episode-card [episodeItem]="episode"
            data-testid="details_episode-item" [attr.data-reference-id]="episode.referenceId"
            [hasUpcomingEnabled]="hasUpcomingEnabled()"
            [hasOutgoingEnabled]="hasOutgoingEnabled()"
            [showAutomaticBadge]="episode.referenceId === latestAvailableEpisodeReferenceId()"
            (availabilityStartPassed)="onEpisodeAvailabilityChanged()">
        </asset-episode-card>
    }
</div>
